"use client";

import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fr } from "date-fns/locale";
import { registerLocale } from "react-datepicker";
import TikTokThumbnail from "../../components/TikTokThumbnail";
import axios from "axios";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";

registerLocale("fr", fr);
const API_URL = process.env.REACT_APP_API_URL;

function getFacebookVideoId(url) {

  // reel
  let match = url.match(/facebook\.com\/reel\/(\d+)/)

  if (match)
    return match[1]

  // watch
  match = url.match(/[?&]v=(\d+)/)

  if (match)
    return match[1]

  // videos
  match = url.match(/facebook\.com\/.*\/videos\/(\d+)/)

  if (match)
    return match[1]

  return null
}

export default function PageAjouterVideo() {
  const { user } = useSelector((state) => state.user);
  const [title, setTitle] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [categorie, setCategorie] = useState("Événements");
  const [date, setDate] = useState(getTodayText());
  const [createdAt, setCreatedAt] = useState(new Date());
  const [thumbnail, setThumbnail] = useState("");
  const [thumbnailError, setThumbnailError] = useState(false);

  // Retourne la date du jour en jj/mm/aaaa
  function getTodayText() {
    const d = new Date();
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Détecte le type de vidéo
 useEffect(() => {

  setThumbnailError(false)

  if (!videoUrl) {

    setThumbnail("")
    return
  }

  // =====================================
  // 🎵 TIKTOK
  // =====================================

  if (videoUrl.includes("tiktok.com")) {

    setThumbnail("")
    return
  }

  // =====================================
  // ▶️ YOUTUBE
  // =====================================

  const ytMatch = videoUrl.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/)

  if (ytMatch && ytMatch[7].length === 11) {

    const id = ytMatch[7]

    setThumbnail(`https://img.youtube.com/vi/${id}/hqdefault.jpg`)

    return
  }

  // =====================================
  // 📘 FACEBOOK
  // =====================================

  if (videoUrl.includes("facebook.com") || videoUrl.includes("fb.watch")) {

  const fbId = getFacebookVideoId(videoUrl)

  if (fbId) {

    // 🔥 vraie tentative thumbnail
    setThumbnail(`https://graph.facebook.com/${fbId}/picture?type=large` )

  } else {

    setThumbnail("/images/facebook-video.jpg")
  }

  return
}

  // =====================================
  // ❌ AUTRE
  // =====================================

  setThumbnail("")

}, [videoUrl])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !videoUrl) {
      alert("Veuillez remplir au moins le titre et l'URL vidéo.");
      return;
    }

    try {
      const payload = {
        title,
        videoUrl,
        categorie,
        date,        // chaîne jj/mm/aaaa
        createdAt,   // objet Date du DatePicker
        image: thumbnail, // YouTube ou TikTok
        href: `/video/${videoUrl.split("/").pop()}`,
      };

      await axios.post(`${API_URL}/api/videos`, payload);
      alert("Vidéo ajoutée avec succès !");

      // Reset formulaire
      setTitle("");
      setVideoUrl("");
      setCategorie("Événements");
      setDate(getTodayText());
      setCreatedAt(new Date());
      setThumbnail("");
    } catch (err) {
      console.error(err);
      alert("Erreur lors de l'ajout de la vidéo.");
    }
  };

  if (!user) return <Page404 />;

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "30px" }}>
      <h2 style={{ marginBottom: "20px" }}>Ajouter une vidéo</h2>

      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "200px 1fr",
            gap: "14px 25px",
            alignItems: "center",
          }}
        >
          <label>Titre :</label>
          <input
            className="input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />

          <label>URL vidéo :</label>
          <input
            className="input"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            required
          />

          <label>Catégorie :</label>
          <select
            className="input"
            value={categorie}
            onChange={(e) => setCategorie(e.target.value)}
          >
            <option>Événements</option>
            <option>Conseils</option>
            <option>Projets</option>
            <option>Photos</option>
          </select>

          <label>Date affichée (jj/mm/aaaa) :</label>
          <input
            type="text"
            className="input"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            placeholder="jj/mm/aaaa"
            pattern="\d{2}/\d{2}/\d{4}"
            title="Format jj/mm/aaaa"
            required
          />

          <label>Date création :</label>
          <DatePicker
            selected={createdAt}
            onChange={(d) => setCreatedAt(d)}
            locale="fr"
            dateFormat="dd/MM/yyyy"
            className="input"
          />
        </div>

        <button
          type="submit"
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            backgroundColor: "green",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Ajouter la vidéo
        </button>
      </form>

      {/* Aperçu du thumbnail */}
      <div style={{ marginTop: "30px" }}>
        <h3>Aperçu :</h3>

        {/* YouTube */}
        {thumbnail && !videoUrl.includes("tiktok.com") && (
          <img
            src={ thumbnailError ? "/images/facebook-video.jpg" : thumbnail }
            onError={() => { setThumbnailError(true) }}
            alt="thumbnail"
            style={{
              maxWidth: "320px",
              borderRadius: "10px",
              display: "block",
              marginTop: "10px",
            }}
          />
        )}

        {/* TikTok */}
        {videoUrl.includes("tiktok.com") && videoUrl && (
          <div style={{ maxWidth: "320px", marginTop: "10px" }}>
            <TikTokThumbnail
              url={videoUrl}
              onThumbnailReady={(thumb) => setThumbnail(thumb)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
